<template>
    <div class="m-tiles-row">
        <component
            :is="tileType"
            v-for="item in preparedItems"
            :key="item.id"
            :item="item"
            @click="handleClick"
        >
            <AFloorInfo
                v-if="item.floorInfo"
                :text="item.floorInfo"
            />
            <AAmountInfo
                v-else-if="item.amountCategories"
                :text="item.amountCategoriesText"
            />
            <span v-else/>
        </component>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import MTile from '../../molecules/m-tile';
import MTileOtg from '../../molecules/m-tile-otg';
import AFloorInfo from '../../atoms/a-floor-info';
import AAmountInfo from '../../atoms/a-amount-info';

export default {
    name: "MTilesRow",
    components: {
        MTile,
        MTileOtg,
        AFloorInfo,
        AAmountInfo
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        tileType: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getPropsMapping',
        ]),
        preparedItems() {
            const props = this.getPropsMapping;

            return this.items.map(el => {
                const item = el?.item || el;

                const name = item.meta[props.name] || item.meta['name'] ||'';
                const amountCategories = item?.objectsCount;
                const amountCategoriesText = amountCategories && this.$t("ui.service.brands-count", { count: amountCategories }, amountCategories);

                const floorInfo = item.meta[props.floor] || item?.floor?.building_index ?
                    _.capitalize(_.replace(item?.floor?.building_index, '_', ' ')) + ', ' +
                    _.capitalize(item?.floor?.meta[props.name]) : '';

                const categories = item.lists?.categories || [];
                const isBrands = categories.length > 0 && item.type !== 'tenant';
                const files = isBrands
                    ? { ...item.files, icon: require('@/assets/images/icons/brands.svg') }
                    : { ...item.files };
                const cssClass = isBrands ? 'tile-brands' : null;

                return {
                    ...item,
                    files,
                    name,
                    amountCategories,
                    amountCategoriesText,
                    floorInfo,
                    cssClass
                }
            })
        }
    },
    methods: {
        handleClick(item) {
            this.$emit('onClick', item);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
